import React from 'react';
import { I18n as I } from 'react-redux-i18n';

import { Modal } from 'antd';

const UpgradeMembershipModal = ({ onHide, show, type }) => {
  return (
    <Modal onCancel={onHide} title="MEMBERSHIP" visible={show} footer={null}>
      <div className="col-12">
        <div className="mt-element-ribbon bg-grey-steel">
          <div className="ribbon ribbon-round ribbon-border-dash ribbon-color-danger uppercase">
            UPGRADE MEMBERSHIP
          </div>
          <p className="ribbon-content">
            {type === 'golden'
              ? I.t('UPGRADE_GOLDEN_MEMBERSHIP')
              : I.t('UPGRADE_SILVER_MEMBERSHIP')}
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default UpgradeMembershipModal;
